import { render } from "./MaterialLogs.vue?vue&type=template&id=38508bfe&scoped=true"
import script from "./MaterialLogs.vue?vue&type=script&lang=js"
export * from "./MaterialLogs.vue?vue&type=script&lang=js"

import "./MaterialLogs.vue?vue&type=style&index=0&id=38508bfe&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38508bfe"]])

export default __exports__